/**
 * Create a new matrix based on the size of the current one or by using specific dimensions
 * Take care that if you specify as ArrayConstructor an Array, the matrix will be filled with 'uhdefined' and not with 0
 */
export function matrixCreateEmpty(options) {
    const { matrix, nbRows = matrix?.length || 1, nbColumns = matrix?.[0].length || 1, ArrayConstructor = Float64Array, } = options;
    const newMatrix = [];
    for (let row = 0; row < nbRows; row++) {
        newMatrix.push(new ArrayConstructor(nbColumns));
    }
    return newMatrix;
}
//# sourceMappingURL=matrixCreateEmpty.js.map